import { gql } from '@apollo/client'

export const GIFT_CARD_APPLY = gql`
    query GiftCardApply($GiftCardApplyInput: GiftCardApplyInput!) {
        GiftCardApply(giftCard: $GiftCardApplyInput) {
            success
            message
            cardData {
                authorization_hash
            }
        }
    }
`

export type GiftCardApplyQueryVariables = {
    GiftCardApplyInput: {
        quoteMaskedId: string
        cardNumber: string
        cardPin: string
        discountAmount: number
        store: string
    }
}

export type GiftCardApplyQuery = {
    GiftCardApply: {
        success: boolean
        message: string
        cardData: {
            authorization_hash: string
        } | null
    }
}